import { useCallback, useEffect, useRef, useState } from "react";

// Shared logic behind every "scroll natiu + fletxes" carousel on the home
// page (propietats, destins, serveis, notícies, testimonis). One place to
// fix instead of five copy-pasted ones — in particular a ResizeObserver on
// the track itself, not just window 'resize', so the enabled/disabled
// state of the arrows stays correct after content reflows that don't fire
// a resize event (images finishing loading, fonts swapping, etc.) — the
// most likely cause of arrows looking "stuck"/unresponsive on mobile.
export default function useHorizontalCarousel(itemSelector, dependency) {
    const trackRef = useRef(null);
    const [navState, setNavState] = useState({ atStart: true, atEnd: false });

    const updateNavState = useCallback(() => {
        const el = trackRef.current;
        if (!el) return;
        const maxScroll = el.scrollWidth - el.clientWidth;
        setNavState({
            atStart: el.scrollLeft <= 2,
            atEnd: el.scrollLeft >= maxScroll - 2,
        });
    }, []);

    useEffect(() => {
        const el = trackRef.current;
        if (!el) return;

        updateNavState();

        el.addEventListener('scroll', updateNavState, { passive: true });
        window.addEventListener('resize', updateNavState);

        let observer;
        if (typeof ResizeObserver !== 'undefined') {
            observer = new ResizeObserver(() => updateNavState());
            observer.observe(el);
        }

        return () => {
            el.removeEventListener('scroll', updateNavState);
            window.removeEventListener('resize', updateNavState);
            if (observer) observer.disconnect();
        };
    }, [dependency, updateNavState]);

    const scrollByCard = useCallback((direction) => {
        const el = trackRef.current;
        if (!el) return;
        const card = el.querySelector(itemSelector);
        const gap = 20;
        const step = card ? card.getBoundingClientRect().width + gap : el.clientWidth * 0.9;
        el.scrollBy({ left: direction * step, behavior: 'smooth' });
    }, [itemSelector]);

    return { trackRef, navState, scrollByCard };
}
